import { render, staticRenderFns } from "./HighCallModal.vue?vue&type=template&id=2cc5d206&scoped=true&"
import script from "./HighCallModal.vue?vue&type=script&lang=js&"
export * from "./HighCallModal.vue?vue&type=script&lang=js&"
import style0 from "./HighCallModal.vue?vue&type=style&index=0&id=2cc5d206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5d206",
  null
  
)

export default component.exports